import React, { useState, useEffect } from 'react';
import { getFirestore, collection, doc, onSnapshot } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';
import VisitsChart from '../../components/VisitsChart/VisitsChart';

const Dashboard = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    nouveautes: 0,
    deals: 0,
    users: 0,
    shops: 0
  });

  // Ajouter un useEffect pour la surveillance en temps réel
  useEffect(() => {
    const db = getFirestore();
    
    const unsubscribePushStats = onSnapshot(doc(db, 'analytics', 'pushStats'), (doc) => {
      if (doc.exists()) {
        const data = doc.data();
        setStats(prev => ({
          ...prev,
          users: data.totalSubscribed || 0
        }));
      }
    });

    const unsubscribeShops = onSnapshot(collection(db, 'shops'), (snapshot) => {
      setStats(prev => ({
        ...prev,
        shops: snapshot.docs.length
      }));
    });

    const unsubscribeNews = onSnapshot(collection(db, 'nouveautes'), (snapshot) => {
      setStats(prev => ({
        ...prev,
        nouveautes: snapshot.docs.length
      }));
    });

    const unsubscribeDeals = onSnapshot(collection(db, 'deals'), (snapshot) => {
      setStats(prev => ({
        ...prev,
        deals: snapshot.docs.length
      }));
    });

    // Cleanup function
    return () => {
      unsubscribePushStats();
      unsubscribeShops();
      unsubscribeNews();
      unsubscribeDeals();
    };
  }, []);

  return (
    <div className="dashboard">
      <div className="dashboard-content">
        <div className="dashboard-container">
          <div className="dashboard-grid">
            <div className="dashboard-card">
              <div className="card-content">
                <h3>Nouveautés</h3>
                <div className="stat-number">{stats.nouveautes}</div>
                <p>Articles publiés</p>
              </div>
            </div>
            <div className="dashboard-card">
              <div className="card-content">
                <h3>Bons Plans</h3>
                <div className="stat-number">{stats.deals}</div>
                <p>Deals partagés</p>
              </div>
            </div>
            <div 
              className="dashboard-card"
              onClick={() => navigate('/subscribers')}
              style={{ cursor: 'pointer' }}
            >
              <div className="card-content">
                <h3>Utilisateurs</h3>
                <div className="stat-number">{stats.users}</div>
                <p>Abonnés aux notifications</p>
              </div>
            </div>
            <div className="dashboard-card">
              <div className="card-content">
                <h3>Boutiques</h3>
                <div className="stat-number">{stats.shops}</div>
                <p>Boutiques référencées</p>
              </div>
            </div>
          </div>

          {/* Graphique des visites */}
          <VisitsChart />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;